<template>
  <div>
    <!-- Fixed navbar -->
    <nav class="navbar navbar-default">
      <div class="container">
        <div class="navbar-header">
          <router-link class="navbar-brand" to="/">FISH FEEDING CHART</router-link>
        </div>
        <!--/.nav-collapse -->
      </div>
    </nav>
    <transition name="fade" v-on:after-leave="scroll">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  methods: {
    scroll() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// App.vue?012fb271